export const ExternalProviderConstants = {
	externalProviderButtonClass: "external-provider-button",
	halfWidth: "half-width",
	odd: "odd",
	even: "even"
};

export class ExternalProviders {
	static Init(providersContainerElement, providers, handler) {
		return new ExternalProviders(providersContainerElement, providers, handler);
	}

	constructor(providersContainerElement, providers, handler) {
		this._RenderExternalProviders(providersContainerElement, providers);
		this._BindClicks(providersContainerElement, handler);
	}

	_RenderExternalProviders(providersContainerElement, providers) {
		providers = (providers || []).sort((a, b) => a.weight - b.weight);

		const halfWidthClassName = providers.length > 1 ? ExternalProviderConstants.halfWidth : "";
		const providerButtons = providers.reduce((acc, provider, idx) => {
			const providerClass = provider.Text.toLowerCase().replace(" ", "-");
			const oddEvenClass = (idx + 1) % 2 === 0 ? ExternalProviderConstants.even : ExternalProviderConstants.odd;
			acc = `
				${acc}
				<div class="external-provider ${halfWidthClassName} ${oddEvenClass}">
					<button type="button" class="${ExternalProviderConstants.externalProviderButtonClass}" value="${provider.Type}">
						<span class="provider-text">
							<i class="provider-icon provider-icon-${providerClass}"></i>
							${provider.Text}
						</span>
					</button>
				</div>`;
			return acc;
		}, "");

		providersContainerElement.innerHTML = providerButtons;

		return providerButtons;
	}

	_BindClicks(externalProvidersContainerElement, handler) {
		externalProvidersContainerElement.addEventListener("click", (e) => {
			const externalProviderButton = e.target.closest(`.${ExternalProviderConstants.externalProviderButtonClass}`);
			if (externalProviderButton) {
				handler && handler(externalProviderButton.value);
			}
		});
	}
}
